/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cus_Success_With_RescheduleInputs */

const en_ticket_action_cus_success_with_reschedule = /** @type {(inputs: Ticket_Action_Cus_Success_With_RescheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit reported as unsuccessful and new date recorded.`)
};

const ja_ticket_action_cus_success_with_reschedule = /** @type {(inputs: Ticket_Action_Cus_Success_With_RescheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訪問は不成功と報告し、新しい日付を記録しました。`)
};

const fr_ticket_action_cus_success_with_reschedule = /** @type {(inputs: Ticket_Action_Cus_Success_With_RescheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visite signalée comme non réussie et nouvelle date enregistrée.`)
};

const de_ticket_action_cus_success_with_reschedule = /** @type {(inputs: Ticket_Action_Cus_Success_With_RescheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuch als nicht erfolgreich gemeldet und neuer Termin erfasst.`)
};

/**
* | output |
* | --- |
* | "Visit reported as unsuccessful and new date recorded." |
*
* @param {Ticket_Action_Cus_Success_With_RescheduleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cus_success_with_reschedule = /** @type {((inputs?: Ticket_Action_Cus_Success_With_RescheduleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cus_Success_With_RescheduleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cus_success_with_reschedule(inputs)
	if (locale === "ja") return ja_ticket_action_cus_success_with_reschedule(inputs)
	if (locale === "fr") return fr_ticket_action_cus_success_with_reschedule(inputs)
	return de_ticket_action_cus_success_with_reschedule(inputs)
});